module.exports = __webpack_public_path__ + "978033f50c3da8910ef01bbfcbb2a7db.png";